import * as React from 'react'
import { Loading, Size } from '@sphinx/react-components'
import { LoaderWrap } from './spinner.styles'

interface SpinnerProps {
  children?: React.ReactNode
}

export const Spinner: React.FC<SpinnerProps> = ({ children }) => (
  <LoaderWrap>
    <Loading size={Size.LARGE} />
    {children}
  </LoaderWrap>
)
